import { matchPath } from "react-router-dom";

import {
  BOOKED_VISIT_CONFIRM_DATE_CONFIRMED_MODAL_PATH,
  BOOKED_VISIT_CONFIRM_DATE_FINALIZE_MODAL_PATH,
  BOOKED_VISIT_CONFIRM_DATE_MODAL_PATH,
  BOOKED_VISIT_DETAILS_PATH,
  BOOKED_VISIT_DROP_CONFIRMED_MODAL_PATH,
  BOOKED_VISIT_DROP_MODAL_PATH,
  BOOKED_VISIT_LOG_CONFIRMED_MODAL_PATH,
  BOOKED_VISIT_LOG_DATE_MODAL_PATH,
  BOOKED_VISIT_LOG_END_TIME_MODAL_PATH,
  BOOKED_VISIT_LOG_FINALIZE_MODAL_PATH,
  BOOKED_VISIT_LOG_START_TIME_MODAL_PATH,
  BOOKED_VISIT_PEND_MODAL_PATH,
} from "../InHome/paths";
import {
  SHIFT_DISCOVERY_IN_HOME_VISIT_BOOKED_MODAL_PATH,
  SHIFT_DISCOVERY_IN_HOME_VISIT_CONFIRM_BOOKING_MODAL_PATH,
  SHIFT_DISCOVERY_IN_HOME_VISIT_MODAL_PATH,
} from "./paths";
import { type InHomeVisitModalRoutePathParams } from "./types";

export function getVisitModalRouteParams<Params extends InHomeVisitModalRoutePathParams>(
  baseNavigationPath: string,
  locationPathname: string
) {
  const match = matchPath<Params>(locationPathname, {
    path: [
      `${baseNavigationPath}/${SHIFT_DISCOVERY_IN_HOME_VISIT_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_IN_HOME_VISIT_CONFIRM_BOOKING_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_IN_HOME_VISIT_BOOKED_MODAL_PATH}`,
      `${baseNavigationPath}/${BOOKED_VISIT_DETAILS_PATH}`,
      `${baseNavigationPath}/${BOOKED_VISIT_CONFIRM_DATE_MODAL_PATH}`,
      `${baseNavigationPath}/${BOOKED_VISIT_CONFIRM_DATE_FINALIZE_MODAL_PATH}`,
      `${baseNavigationPath}/${BOOKED_VISIT_CONFIRM_DATE_CONFIRMED_MODAL_PATH}`,
      `${baseNavigationPath}/${BOOKED_VISIT_PEND_MODAL_PATH}`,
      `${baseNavigationPath}/${BOOKED_VISIT_DROP_MODAL_PATH}`,
      `${baseNavigationPath}/${BOOKED_VISIT_DROP_CONFIRMED_MODAL_PATH}`,
      `${baseNavigationPath}/${BOOKED_VISIT_LOG_DATE_MODAL_PATH}`,
      `${baseNavigationPath}/${BOOKED_VISIT_LOG_START_TIME_MODAL_PATH}`,
      `${baseNavigationPath}/${BOOKED_VISIT_LOG_END_TIME_MODAL_PATH}`,
      `${baseNavigationPath}/${BOOKED_VISIT_LOG_FINALIZE_MODAL_PATH}`,
      `${baseNavigationPath}/${BOOKED_VISIT_LOG_CONFIRMED_MODAL_PATH}`,
    ],
    exact: true,
    strict: false,
  });

  return match?.params;
}
